import * as WpsTypes from 'DVWebNodeWpsRuntime'
import { createMergeReducer } from '../utils/reducer'

export type TitleIdToFaq = {
  [titleId: string]: WpsTypes.atv.wps.FaqModelProps | undefined
}

export const reducer = createMergeReducer(
  t => t.faq,
  {} as TitleIdToFaq
)
